import { render, staticRenderFns } from "./SendMessageButton.vue?vue&type=template&id=620f0a49"
import script from "./SendMessageButton.vue?vue&type=script&lang=js"
export * from "./SendMessageButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports